import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material.module';
import { KendoModule } from '../kendo.module';
import { DatasourceDatasSelectionResultComponent } from './datasource-datas-selection-result/datasource-datas-selection-result.component';
import { DatasourceDatasSelectionDesignComponent } from './datasource-datas-selection-design/datasource-datas-selection-design.component';
import { DatasourceDatasSelectionFormComponent } from './datasource-datas-selection-form/datasource-datas-selection-form.component';
import { DynamicDatasourceDatasSelectionComponent } from './dynamic-datasource-datas-selection.component';
import { DatasourceDatasSelectionDialogComponent } from './datasource-datas-selection-dialog/datasource-datas-selection-dialog.component';
import { AbwDatatableModule } from '../../abw-datatable/abw-datatable.module';
import { AbwMatDatatableModule } from '../../abw-mat-datatable/abw-mat-datatable.module';

@NgModule({
    declarations: [
        DatasourceDatasSelectionResultComponent,
        DatasourceDatasSelectionDesignComponent,
        DatasourceDatasSelectionFormComponent, DynamicDatasourceDatasSelectionComponent,
        DatasourceDatasSelectionDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        KendoModule,
        AbwDatatableModule,
        AbwMatDatatableModule
    ],
    exports: [
        DatasourceDatasSelectionFormComponent
    ],
    entryComponents: [
        DynamicDatasourceDatasSelectionComponent,
        DatasourceDatasSelectionDialogComponent
    ]
})
export class DatasourceDatasSelectionModule {}